// |Importing components
import { Http } from '@angular/http';
import { RequestOptions } from '@angular/http';
import { Injectable } from '@angular/core';
import { Headers } from '@angular/http';
import { Locale } from './locale.service';
import { ServerMapping } from './serverMapping.service';
import { Status } from './status.service';
import { GrowlManager } from './../manager/growl.manager';

// |Measure Unit class
export class MeasureUnit {
    code: string;
    label: string;
    constructor(code: string, label: string) {
        this.code = code;
        this.label = label;
    }
}


// |This class is the master class of the code
@Injectable()
export class CustomizingService {
    // variable declaration
    private customizeParam = [];

    // |Constructor method
    constructor(private http: Http,
                private locale: Locale,
                private serverMapping: ServerMapping,
                private growlManager: GrowlManager,
                private status: Status) { }

    // |Function that wipes all the stored data about the configuration
    clearAllData() {
        this.customizeParam = [];
    }

    // |Customize the app
    loadCustomizing() {
        this.http.get( this.serverMapping.customizeURL).subscribe(
            (response) => {
                const data = response.json();
                this.setCustomize(data.contained_bean.customizing_list);
            },
            (error) => {
            }
        );
    }

    // |Call the web service and get the data from /loadtab
    loadTable(value: string) {
        // make the request
        return this.http.get(this.serverMapping.configURL +
                      '?purchase_organization=' + value +
                      '&language=' + this.locale.getPreferredLanguage()).map(
            (response) => {
                // obtain the data
                console.log('config');
                const data = response.json();

                // this.clearAllData();

                return data;
            },
            (error) => {console.log('OPS ' + error); }
        );
    }

    // |==========|CUSTOMIZATION PARAMS HANDLER|==========|
    // |Set customize values
    setCustomize(values) {
        this.customizeParam = [];
        if (values !== undefined) {
            for (const element of values) {
                this.customizeParam.push(element);
            }

            this.growlManager.setErrorDuration(this.getInt('SERVICE.GROWL.ERROR_DURATION', '10000'));
            this.growlManager.setSuccessDuration(this.getInt('SERVICE.GROWL.INFO_DURATION', '10000'));
            this.growlManager.setWarningDuration(this.getInt('SERVICE.GROWL.WARNING_DURATION', '10000'));

        } else {
            console.log('[paramService] No data for ZSRH_CUSTOMIZING found!');
        }
    }

    // |Check if a param key exist
    checkParam(key: string) {
        let found = false;
            for (const element of this.customizeParam) {
                if (element.key === key) {
                found = true;
                break;
            }
        }
        return found;
    }

    // |Get a boolean key
    getBoolean(key, defaultValue) {
        let value = false;
        if (this.checkParam(key) === true) {
            for (const element of this.customizeParam) {
                if (element.key === key) {
                    if (element.text === 'true') {
                         value = true;
                    }
                    break;
                }
            }
        } else {
            if (defaultValue === 'TRUE') {
                return true;
            } else {
                return false;
            }
        }
        return value;
    }

    // |Get a string key
    getString(key, defaultValue) {
        let value = false;
        if (this.checkParam(key) === true) {
            for (const element of this.customizeParam) {
                if (element.key === key) {
                    return element.text;
                }
            }
        } else {
            return defaultValue;
        }
        return value;
    }

    // |Get an int key
    getInt(key, defaultValue) {
        return Number(this.getString(key, defaultValue));
    }
}



// WEBPACK FOOTER //
// ./src/app/service/customizingService.service.ts